import React from 'react';
import { Spin } from 'components/ds';
import { ButtonLarge } from '../../../../components/Css';
import Logo from 'components/Logo';
import { useNavigate } from 'react-router-dom';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import {
  ImageContainer,
  ImageWrapper,
  Img,
  LinkCopyRigth,
  LinkRegister,
  LinkText,
  WelcomeContainer,
  WelcomeFooter
} from './Welcome.styles';
import { pageConfigs } from '../../configs/pageConfigs';
import { getDeviceType } from 'utils/useDeviceType';
import { useSchema } from 'modules/account/hooks/useSchema';
import { useClearAllData } from '../../hooks/useDataCleaner';

const Welcome = () => {
  const {clearAllData} = useClearAllData();
  const {checkIsOpenFlow, getSchema} = useSchema();
  
  const {isLoading} = useGetTemplate(pageConfigs.welcome.template);
  
  const navigate = useNavigate();
  
  const theme = ApiLocalStorage.get('theme') || {};

  const handleRegisterClick = () => {
    clearAllData();
    const route = pageConfigs.welcome.navigateToRegister();
    navigate(route);
  };

  const handleGoToUserAuth = () => {
    const route = pageConfigs.welcome.navigateToUserName();
    navigate(route);
  };

  // Debug logs
  const isOpenFlow = checkIsOpenFlow();
  const schemaData = getSchema();


  if (isLoading) {
    return (
      <WelcomeContainer>
        <Spin/>
      </WelcomeContainer>
    );
  }
  
  const getBannerTheme = () => {
    if (getDeviceType() === 'mobile') {
      return theme?.login?.bannerMobile || theme?.login?.banner
    }
    
    return theme?.login?.banner
  }
  
  const logo = theme?.login?.logo;
  const hideLogoOnWelcome = theme?.login?.hideLogoOnWelcome;
  const footerExtraInfo = theme.welcome;
  
  return (<>
      <WelcomeContainer>
        {
          logo && (
            <ImageWrapper>
              <Logo/>
            </ImageWrapper>
          )
        }
        
        <ImageContainer className="vert-fml-welcome-banner">
          <Img src={getBannerTheme()} alt='Welcome Image'/>
        </ImageContainer>
        
        <WelcomeFooter className='welcome-footer-container'>
          <ButtonLarge
            className="vert-fml-welcome-button"
            onClick={handleGoToUserAuth}
          >
            Entrar
          </ButtonLarge>
          {checkIsOpenFlow() && (
            <LinkRegister className='welcome-footer-box'>
              Primeira vez aqui?
              <LinkText onClick={handleRegisterClick}> Cadastre-se</LinkText>
            </LinkRegister>
          )}
          
          {
            footerExtraInfo &&
            <div className='welcome-footer-box'>
              <span>{footerExtraInfo?.footerExtraInfo}</span>
              <a href={footerExtraInfo?.footerExtraInfoUrl} target='_blank' rel='noreferrer'>
                <LinkCopyRigth onClick={handleRegisterClick}> {footerExtraInfo?.footerExtraInfoUrl}</LinkCopyRigth>
              </a>
            </div>
          }
        
        </WelcomeFooter>
      
      </WelcomeContainer>
    </>
  );
};

export default Welcome;
